import React, { useState, useEffect, useCallback, useRef } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import BidAuctionCard from '../BidAuctionCard/BidAuctionCard'
import BidCarouselPrev from './BidCarouselPrev'
import BidCarouselNext from './BidCarouselNext'
import CardSlider from '@components/CardSlider'

export default function BidAuctionCarousel({ auctions }: any) {
  return (
    <CardSlider>
      {({ trackHeight }) => (
        <>
          {auctions.map((auction: any, i: any) => (
            <div
              className={`embla__slide h-full flex`}
              key={auction.id}
              style={{ height: `${trackHeight}px` }}
            >
              <BidAuctionCard auction={auction} inCarousel />
            </div>
          ))}
        </>
      )}
    </CardSlider>
  )
}
